import React from "react";
import cn from "classnames";
import ReactDOMServer from "react-dom/server";

export enum ButtonTypeEnum {
  primary = "primary",
  secondary = "secondary",
  bordered = "bordered",
  borderedSecondary = "borderedSecondary",
  text = "text",
}

interface ButtonProps {
  text?: string;
  block?: boolean;
  children?: React.ReactNode;
  loading?: boolean;
  type?: string;
  rounded?: boolean;
  buttonSize?: string;
  reloads?: boolean;
  onClick?: () => void;
  // icon?: keyof typeof IconEnum;
}

interface NativeProps {
  href?: string;
  disabled?: boolean;
  nativeType?: "button" | "submit" | "reset";
}

export type ButtonElement = HTMLButtonElement & HTMLAnchorElement;

type Props = React.HTMLProps<ButtonElement> & NativeProps & ButtonProps;

const Button: React.FC<Props> = ({
  type,
  text,
  block,
  nativeType,
  buttonSize,
  rounded,
  loading,
  className,
  reloads,
  children,
  onClick,
  ...rest
}: Props) => {
  const ctaClass = cn(
    className,
    "Button",
    `Button__${type}`,
    `Button__${buttonSize}`,
    {
      Button__block: block,
      Button__loading: loading,
      Button__rounded: rounded,
    }
  );
  return (
    <button
      type={nativeType}
      className={ctaClass}
      disabled={!loading ? rest.disabled : true}
      onClick={onClick}
    >
      <span className="spinner" />
      <span className="flex items-center justify-center">{children}</span>
    </button>
  );
};

Button.defaultProps = {
  type: "primary",
  nativeType: "button",
  buttonSize: "medium",
  rounded: true,
};

export default Button;
